export const environment = {
  production: true,
  client_id: '3484ad82-9fdd-4312-81f9-797f2c1c4939',
  authority:
    'https://login.microsoftonline.com/5dbf1add-202a-4b8d-815b-bf0fb024e033',
  product_name: 'ExpertGuidance Build Management Portal',
  product_version: 'VA27A',
  front_end_version: '4.0.4',
  windows_QR_Code:'https://moa-storage-dev.s3.eu-west-1.amazonaws.com/eg_assets/Dev-Windows-QR-Code.png',
};
